module.exports = __webpack_public_path__ + "img/morrisons-4-3-ratio.f2a96ee3.jpg";